import { InPersonAppointmentConfirmationToast } from '@/components/appointments/confirmationToasts/InPersonAppointmentConfirmationToast';
import { AppointmentConfirmationType } from '@/utils/appointments';
import { LOCATION } from '@/utils/constants';
import { Location } from '@/utils/types';
import { DefaultAppointmentConfirmationToast } from './DefaultAppointmentConfirmationToast';

export const AppointmentConfirmationToast = ({
  confirmationType,
  location,
}: {
  confirmationType: AppointmentConfirmationType;
  location: Location;
}) => {
  if (location === LOCATION.IN_PERSON) {
    return (
      <InPersonAppointmentConfirmationToast
        fallback={() => (
          <DefaultAppointmentConfirmationToast
            confirmationType={confirmationType}
          />
        )}
      />
    );
  }

  return (
    <DefaultAppointmentConfirmationToast confirmationType={confirmationType} />
  );
};
